import { create } from 'zustand';

const useSocketStore = create((set) => ({
  socket: null,
  setSocket: (newSocket) => set((state) => ({ socket: newSocket })),
}));

export default useSocketStore;

